

import Settings from "@/services/Settings";
import {Options, Vue} from "vue-class-component";
import Subtitle from "@/components/elements/Subtitle.vue";
import GameTitle from "@/components/title/GameTitle.vue";
import SocialMediaStat from "@/components/elements/SocialMediaStat.vue";
import Header from "@/components/elements/Header.vue";
import Hero from "@/components/elements/Hero.vue";

@Options({
  components: {
    Subtitle,
    GameTitle,
    SocialMediaStat,
    Header,
    Hero
  },
})
export default class Game extends Vue {
  private id: string | null = null;
  private host: string | null = null;
  private loader = false;
  private game: any = {};

  loadData() {
    if (this.loader) return;
    this.loader = true;
    this.$http.get(this.host + '/public/games/' + this.id, {
      params: {}
    }).then((response) => {
      this.game = response.data;
    }, () => {
      this.loader = false;
    });
  }

  mounted() {
    this.id = this.$route.params.gameId as string;
    const settings = new Settings();
    this.host = settings.getSetting('apiHost');
    this.loadData();
  }
}

